export const columns = [
	{
		id: 'name',
		label: 'Documento',
		width: '400px',
	},
	{
		id: 'type',
		label: 'Tipo',
		width: '150px',
	},
	{
		id: 'category',
		label: 'Categoría',
		width: '250px',
	},
	{
		id: 'created',
		label: 'Fecha de creación',
		width: '150px',
	},
];
